export default "__VITE_ASSET__B8rHm$nJ__"